
{
  "familyId": "REK-HANDIG-PLUS-MIN",
  "questions": [
    {
      "id": "REK-HANDIG-PLUS-MIN-M01",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 48 + 37. Welke manier is het handigst?",
      "options": [
        "Splitsen: 48 + 30 = 78, dan 78 + 7 = 85",
        "Cijferend: 8 + 7 = 15, schrijf 5, onthoud 1, 4 + 3 + 1 = 8 → 85",
        "Allebei optellen bij 40: 40 + 30 = 70, dan 8 + 7 = 15, samen 85",
        "Compenseren: 48 + 40 = 88, dan 88 − 3 = 85"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 40,
            "end": 90,
            "step": 5,
            "highlight": [48, 78, 85],
            "marked": [48, 78, 85],
            "label": "Splitsen: 48 → +30 → 78 → +7 → 85"
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 40,
            "end": 90,
            "step": 5,
            "highlight": [48, 78, 85],
            "marked": [48, 78, 85],
            "label": "Sprongen op de getallenlijn: 48 +30→ 78 +7→ 85"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Splitsen — handig optellen",
            "content": "Bij splitsen verdeel je één getal in tientallen en eenheden. 48 + 37: splits 37 in 30 + 7. Eerst: 48 + 30 = 78. Dan: 78 + 7 = 85. Dit is sneller dan cijferend rekenen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_splitsen_optellen",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Splitsen is hier het handigst: splits 37 in 30 + 7. Eerst 48 + 30 = 78, dan 78 + 7 = 85. Alle vier de manieren geven het juiste antwoord (85), maar splitsen is het snelst omdat je in twee stappen klaar bent.",
        "solutionSteps": [
          "Kies een handige manier: splitsen (37 = 30 + 7)",
          "Stap 1: 48 + 30 = 78",
          "Stap 2: 78 + 7 = 85"
        ],
        "distractorExplanations": {
          "0": "Goed! Splitsen is hier de handigste manier. In twee stappen ben je klaar: 48 + 30 = 78, dan 78 + 7 = 85.",
          "1": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig rekenen'. Bij handig rekenen gebruik je slimme trucs die sneller zijn dan de standaard manier.",
          "2": "Beide getallen splitsen werkt ook, maar is meer werk: je moet 40 + 30 = 70 en 8 + 7 = 15 apart uitrekenen en dan optellen. Splitsen van alleen het tweede getal is sneller.",
          "3": "Compenseren (48 + 40 − 3) werkt, maar is hier niet de handigste keuze. Compenseren is vooral handig als een getal dicht bij een tiental ligt, zoals 48 + 39 (→ 48 + 40 − 1)."
        }
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-M02",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 63 − 28. Welke manier is het handigst?",
      "options": [
        "Compenseren: 63 − 30 = 33, dan 33 + 2 = 35",
        "Splitsen: 63 − 20 = 43, dan 43 − 8 = 35",
        "Cijferend: 13 − 8 = 5, 5 − 2 = 3 → 35",
        "Rijgen: 63 − 3 = 60, dan 60 − 25 = 35"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Compenseren — handig aftrekken",
            "content": "Bij compenseren rond je af naar een handig getal. 28 is bijna 30. Trek 30 af: 63 − 30 = 33. Je hebt 2 te veel afgetrokken, dus tel 2 erbij: 33 + 2 = 35.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_compenseren_aftrekken",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Compenseren is hier het handigst: 28 is bijna 30. Trek 30 af: 63 − 30 = 33. Je hebt 2 te veel afgetrokken, dus tel 2 erbij: 33 + 2 = 35. Compenseren werkt het best als een getal dicht bij een tiental ligt.",
        "solutionSteps": [
          "Herken: 28 is bijna 30 → compenseren",
          "Stap 1: 63 − 30 = 33",
          "Stap 2: 33 + 2 = 35 (je trok 2 te veel af)"
        ],
        "distractorExplanations": {
          "0": "Goed! Compenseren is hier het handigst. 28 ≈ 30, dus 63 − 30 = 33, plus 2 terug = 35.",
          "1": "Splitsen werkt ook, maar 43 − 8 is lastiger hoofdrekenen dan 33 + 2. Compenseren is hier sneller omdat 28 dicht bij 30 ligt.",
          "2": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig rekenen'. Het doel is om een slimmere strategie te kiezen.",
          "3": "Rijgen (63 − 3 = 60, dan 60 − 25 = 35) werkt, maar je moet 28 splitsen in 3 + 25, wat niet voor de hand ligt. Compenseren naar 30 is logischer."
        }
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-M04",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 99 + 56. Welke strategie is het handigst?",
      "options": [
        "Compenseren: 100 + 56 = 156, dan 156 − 1 = 155",
        "Splitsen: 99 + 50 = 149, dan 149 + 6 = 155",
        "Cijferend: 9 + 6 = 15, schrijf 5, 9 + 5 + 1 = 15 → 155",
        "Rijgen: 99 + 1 = 100, dan 100 + 55 = 155"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Compenseren bij bijna-tientallen",
            "content": "99 is bijna 100! Reken: 100 + 56 = 156. Je hebt 1 te veel opgeteld, dus trek 1 af: 156 − 1 = 155. Compenseren is ideaal als een getal dicht bij een rond getal ligt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_compenseren_optellen",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "99 is bijna 100 — compenseren is hier ideaal! 100 + 56 = 156, min 1 = 155. Compenseren werkt het best als een getal dicht bij een rond getal ligt (99 ≈ 100, 198 ≈ 200, 47 ≈ 50).",
        "solutionSteps": [
          "Herken: 99 is bijna 100 → compenseren",
          "Stap 1: 100 + 56 = 156",
          "Stap 2: 156 − 1 = 155 (je telde 1 te veel op)"
        ],
        "distractorExplanations": {
          "0": "Goed! 99 ≈ 100, dus 100 + 56 = 156, min 1 = 155. Compenseren is hier de snelste strategie.",
          "1": "Splitsen werkt ook, maar 99 + 50 = 149 is lastiger dan 100 + 56 = 156. Compenseren naar 100 maakt het makkelijker.",
          "2": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig'. Bij handig rekenen zoek je een slimmere weg.",
          "3": "Rijgen (99 + 1 = 100, dan 100 + 55) is eigenlijk ook compenseren, maar dan in twee stappen. De eerste optie is dezelfde strategie in één denkstap."
        }
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-004",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "fill_in",
      "question": "Reken handig uit: 298 + 47",
      "options": [],
      "correctAnswer": "345",
      "data": {
        "acceptedAnswers": ["345"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Compenseren: 298 ≈ 300",
            "content": "298 is bijna 300. Reken: 300 + 47 = 347. Je telde 2 te veel op, dus trek 2 af: 347 − 2 = 345.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_compenseren_driehonderd",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "298 is bijna 300 — compenseren! 300 + 47 = 347. Je telde 2 te veel op: 347 − 2 = 345. Dit is veel sneller dan cijferend rekenen.",
        "solutionSteps": [
          "Herken: 298 ≈ 300 → compenseren",
          "300 + 47 = 347",
          "347 − 2 = 345 (2 te veel opgeteld)"
        ]
      }
    },
    {
      "id": "REK-HANDIG-PLUS-MIN-005",
      "familyId": "REK-HANDIG-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "handig",
      "subSkill": "handig_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een schilder koopt 145 liter verf en daarna nog 87 liter. Hoeveel liter heeft hij in totaal? Reken handig.",
      "options": ["232 liter", "222 liter", "242 liter", "230 liter"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Splitsen in context",
            "content": "145 + 87: splits 87 in 80 + 7. Eerst: 145 + 80 = 225. Dan: 225 + 7 = 232. Of compenseer: 145 + 90 = 235, min 3 = 232.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_context_optellen",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "145 + 87: splits 87 in 80 + 7. Eerst 145 + 80 = 225, dan 225 + 7 = 232. Of compenseer: 87 ≈ 90, dus 145 + 90 = 235, min 3 = 232 liter.",
        "solutionSteps": [
          "Herken de bewerking: 145 + 87",
          "Strategie 1 (splitsen): 145 + 80 = 225, dan 225 + 7 = 232",
          "Strategie 2 (compenseren): 145 + 90 = 235, dan 235 − 3 = 232"
        ],
        "distractorExplanations": {
          "0": "Goed! 145 + 87 = 232 liter. Splitsen of compenseren — beide werken hier goed.",
          "1": "Je dacht waarschijnlijk 145 + 80 = 225, maar vergat de 7 erbij te tellen. 225 − 3 = 222 klopt niet — je moet 225 + 7 = 232 rekenen.",
          "2": "Je dacht waarschijnlijk 145 + 90 = 235, plus 7 = 242. Maar als je 90 optelt in plaats van 87, heb je 3 te veel opgeteld. Trek 3 af: 235 − 3 = 232.",
          "3": "Je dacht waarschijnlijk 145 + 85 = 230. Maar het is 87, niet 85. 145 + 87 = 232."
        }
      }
    }
  ]
}
